import { render, staticRenderFns } from "./Boletas.vue?vue&type=template&id=05058690&scoped=true"
import script from "./Boletas.vue?vue&type=script&lang=ts"
export * from "./Boletas.vue?vue&type=script&lang=ts"
import style0 from "./Boletas.vue?vue&type=style&index=0&id=05058690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05058690",
  null
  
)

export default component.exports